export const TEAK_BOOKING_STATUS = {
	confirmed: 'confirmed',
	checkedIn: 'checkedIn',
	cancelled: 'cancelled',
	checkInOpen: 'checkInOpen',
};
